import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import BenefitInfoPanel from '../../../component/benefitTabs/BenefitInfoPanel';
import CarChargingImg from '/image/car/car-charging.png';

const CarInfoPanel: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('benefitsModule');

  return (
    <BenefitInfoPanel
      backgroundImage={CarChargingImg}
      title={t('CAR.info.title')}
      description={t('CAR.info.description')}
      primaryButtonLabel={t('CAR.info.learnMore')}
      onPrimaryClick={() => navigate('/benefits/car/learnMore')}
      secondaryButtonLabel={t('CAR.info.connected')}
      onSecondaryClick={() => navigate('/benefits/car/connect')}
    />
  );
};
export default CarInfoPanel;
